module.exports = __webpack_public_path__ + "static/media/custPrintLetterhead.52f85a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/estimates/custPrintLetterhead.png
// module id = 175
// module chunks = 0